module.exports = __webpack_public_path__ + "images/emoji/vs.4b3ff7687246633149fe.png";